import { render, staticRenderFns } from "./ReservePsychologyTeacher.vue?vue&type=template&id=29bae61e&scoped=true"
import script from "./ReservePsychologyTeacher.vue?vue&type=script&lang=js"
export * from "./ReservePsychologyTeacher.vue?vue&type=script&lang=js"
import style0 from "./ReservePsychologyTeacher.vue?vue&type=style&index=0&id=29bae61e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bae61e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29bae61e')) {
      api.createRecord('29bae61e', component.options)
    } else {
      api.reload('29bae61e', component.options)
    }
    module.hot.accept("./ReservePsychologyTeacher.vue?vue&type=template&id=29bae61e&scoped=true", function () {
      api.rerender('29bae61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassOverviewDetail/components/RemindStuDetail/components/ReservePsychologyTeacher.vue"
export default component.exports